module.exports = __webpack_public_path__ + "img/Logos_login.4395453b.png";